import { render, staticRenderFns } from "./table-numbers.vue?vue&type=template&id=f2289920&scoped=true"
import script from "./table-numbers.vue?vue&type=script&lang=js"
export * from "./table-numbers.vue?vue&type=script&lang=js"
import style0 from "./table-numbers.vue?vue&type=style&index=0&id=f2289920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2289920",
  null
  
)

export default component.exports